import Swiper from "swiper";
import { Navigation } from "swiper/modules";

const caseStudiesEls = document.querySelectorAll(".case-studies-list");

caseStudiesEls.forEach((section) => {
    const swiperCaseStudiesContentEl =
        section.querySelector(".case-study-swiper");
    const caseStudiesSwiper = new Swiper(swiperCaseStudiesContentEl, {
        modules: [Navigation],
        navigation: {
            nextEl: ".case-study-swiper-button-next",
            prevEl: ".case-study-swiper-button-prev",
        },
        spaceBetween: 20,
        slidesPerView: 1.2,
    });
    const indexElement = section.querySelector(".case-study-swiper-index");
    if (indexElement) {
        caseStudiesSwiper.on("slideChange", function () {
            indexElement.textContent = `${this.realIndex + 1}/${
                this.slides.length
            }`;
        });
    }
});
